import { useDispatch } from "react-redux";
import { useState } from "react";
import { Field } from "formik";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import classnames from "classnames";

import useTranslate from "../../../hooks/use-translate.hook";
import { Input, flex } from "../../../ui";
import { deleteLossReason } from "./loss-reason.actions";

const LossReasonList = ({ form, remove }) => {
    const dispatch = useDispatch();

    const t = useTranslate();

    const [ showConfirmationDelete, setShowConfirmationDelete ] = useState( false );
    const [ showDeleteForbiddenDialog, setShowDeleteForbiddenDialog ] = useState( false );
    const [ index, setIndex ] = useState( null );

    const toggleDeleteForbiddenDialog = () => setShowDeleteForbiddenDialog( !showDeleteForbiddenDialog );

    const toggleConfirmationDelete = ( lossReason, index ) => {
        if ( !showConfirmationDelete ) {
            if ( form.values.lossReasons.filter( field => field.id ).length === 1 ) {
                toggleDeleteForbiddenDialog();
                return;
            }

            if ( !lossReason.id ) {
                remove( index );
                return;
            }
        }
        setShowConfirmationDelete( !showConfirmationDelete );
        setIndex( index );
    };

    const handleDelete = () => {
        dispatch( deleteLossReason( form.values.lossReasons[ index ] ) );
        toggleConfirmationDelete();
    };

    return (
        <div>
            <Dialog
                open={ showConfirmationDelete }
                onClose={ toggleConfirmationDelete }
            >
                <DialogTitle>{ t( "config:loss-reasons.delete.title" ) }</DialogTitle>
                <DialogContent>
                    <DialogContentText>{ t( "config:loss-reasons.delete.comment" ) }</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={ toggleConfirmationDelete }>
                        { t( "common:no" ) }
                    </Button>
                    <Button color="primary" onClick={ handleDelete }>
                        { t( "common:yes" ) }
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={ showDeleteForbiddenDialog }
                onClose={ toggleDeleteForbiddenDialog }
            >
                <DialogTitle>{ t( "config:loss-reasons.delete.title" ) }</DialogTitle>
                <DialogContent>
                    <DialogContentText>{ t( "config:loss-reasons.delete.forbidden" ) }</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={ toggleDeleteForbiddenDialog }>
                        { t( "common:ok" ) }
                    </Button>
                </DialogActions>
            </Dialog>

            {
                form.values.lossReasons.map( ( lossReason, index ) => (
                    <div className={ classnames( flex.container, flex.alignItemsCenter ) } key={ index }>
                        <Field
                            type="text"
                            label=""
                            placeholder={ t( "config:loss-reasons.item.placeholder" ) }
                            name={ `lossReasons[${index}].name` }
                            className={ flex.fill }
                            component={ Input }
                        />
                        <Tooltip title={ t( "common:exclude" ) }>
                            <IconButton onClick={ () => toggleConfirmationDelete( lossReason, index ) } size="large">
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                ))
            }
        </div>
    );
};

export default LossReasonList;